'use client';

import { Wizard } from '@/components/wizard/Wizard';

import { SetupVpcPeeringCreationFlow } from './SetupVpcPeeringCreationFlow';
import {
  defaultSetupVpcPeeringWizardState,
  type SetupVpcPeeringWizardState,
} from './setupVpcPeeringWizardState';

interface SetupVpcPeeringWizardPanelProps {
  workspaceId: string;
  onAbort: () => void;
  onCreated: () => void;
}

export function SetupVpcPeeringWizardPanel({
  workspaceId,
  onAbort,
  onCreated,
}: SetupVpcPeeringWizardPanelProps) {
  return (
    <Wizard<SetupVpcPeeringWizardState>
      onAbort={onAbort}
      hideBackArrow={true}
      onFinish={async () => {
        onCreated();
        return true;
      }}
      flow={[SetupVpcPeeringCreationFlow]}
      initialState={{ ...defaultSetupVpcPeeringWizardState, workspaceId }}
      title='Set up VPC Peering'
      stepperLabels={[]}
    />
  );
}
